// src/redux/Slices/userActivitySlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import activityApi from "../../services/activityApi";
import pathConstant from "../../lib/constants/pathConstant";
import activityCodes from "../../lib/constants/activityCodes";

// Define the async thunk for sending user activity
export const createUserActivity = createAsyncThunk(
  "userActivity/createUserActivity",
  async (data) => {
    try{
        const { location } = data;
        const pageDescription = pathConstant[location.pathname];
        const activityDetails = {
          actionType: activityCodes.pageViewed, // Example activity code, replace with your constant
          pageName: pageDescription,
        };

        const requestData = {
          activityDetails: JSON.stringify(activityDetails),
        };

        // Call the API to send user activity
        const response = await activityApi.requestCreateActivity(requestData);
        return response.data;
      } catch ( error ) {
        console.log("Activity Error", error);
    }
  }
);

export const createButtonActivity = createAsyncThunk(
  "userActivity/createButtonActivity",
  async ({ actionType, buttonName, responseMessage = "" }) => {
    try {
      const activityDetails = {
        actionType,       // Type of button activity (e.g., ADD_TO_CART_CLICKED)
        buttonName,       // Name of the button (e.g., "Add to Cart", "Checkout")
        responseMessage,  // Optional: Success or failure message for API responses
      };

      const requestData = {
        activityDetails: JSON.stringify(activityDetails),
      };

      // Call the API to log button activity
      const response = await activityApi.requestCreateActivity(requestData);
      return response.data;
    } catch (error) {
      console.log("Button Activity Error", error);
    }
  }
);

const userActivitySlice = createSlice({
  name: "userActivity",
  initialState: {
    activity: ""
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, createUserActivity, 'activity');
    handleAsyncThunk(builder, createButtonActivity, "activity");
  },
});

export default userActivitySlice.reducer;
